module.exports = __webpack_public_path__ + "static/media/Ellipsis-Grey.d002f2bf.svg";